function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M59.7,36.61l-.44-1.06-2.58-6.26-.24-.58v0a2.8,2.8,0,0,0-.2-.32,4.91,4.91,0,0,0-2.42-2.12,2.78,2.78,0,0,0-.52-.2L53.1,26v-1.7H50.68v1.58l.16.06c-.06,0-.12,0-.16,0l-.16,0v-.2s-.06,0-.08,0a6.39,6.39,0,0,0-.84-.2,6.1,6.1,0,0,0-1.34-.14,7.32,7.32,0,0,0-3.7,1,7,7,0,0,0-2.12,1.92A5.4,5.4,0,0,0,42,29a7.06,7.06,0,0,0-1,3.8,7.18,7.18,0,0,0,3.56.94l.6,0-.76,1.84L44,36.63a8.66,8.66,0,0,0-.42,2.62,8.29,8.29,0,0,0,6.06,8,6.21,6.21,0,0,0,.92.2,7.12,7.12,0,0,0,.94.1h.76a9.39,9.39,0,0,0,1.08-.12l.52-.1a8.28,8.28,0,0,0,4.64-3.08,7.09,7.09,0,0,0,.64-.94,8.31,8.31,0,0,0,1-4A8.21,8.21,0,0,0,59.7,36.61ZM46,30.73a4.35,4.35,0,0,1-1.44.24l-.42,0a4.44,4.44,0,0,1,.42-.74,2.36,2.36,0,0,1,.34-.44,3.93,3.93,0,0,1,1.08-.9,4.76,4.76,0,0,1,1.46-.54,3.68,3.68,0,0,1,.82-.08,3,3,0,0,1,.42,0,3,3,0,0,1-.3.56,4,4,0,0,1-.5.68l-.12.12-.06.06a4.53,4.53,0,0,1-.84.66l-.36.18-.32.14ZM56.42,42.31a6,6,0,0,1-.44.56,5.32,5.32,0,0,1-2.16,1.52,5.16,5.16,0,0,1-.52.16,5.41,5.41,0,0,1-1.16.2h-.6a5.44,5.44,0,0,1-1-.16,4.54,4.54,0,0,1-.92-.32,5.46,5.46,0,0,1-3.28-5,5.76,5.76,0,0,1,.26-1.66l.4-1,1.72-4.16a.2.2,0,0,0,.1-.08,6.23,6.23,0,0,0,.8-.64,1,1,0,0,1,.16-.14v0a1.8,1.8,0,0,0,.18-.2,1.1,1.1,0,0,0,.14-.18,8.79,8.79,0,0,0,.56-.72,5,5,0,0,0,.42-.7,9.56,9.56,0,0,0,.38-1,1.18,1.18,0,0,0,.08-.16l.06,0h.36l.14,0h.06a2.09,2.09,0,0,1,1.16.5,2,2,0,0,1,.52.56s0,0,0,.06l0,.06,0,0,.2.5,2.6,6.26.38,1a5.27,5.27,0,0,1,.26,1.68A5.47,5.47,0,0,1,56.42,42.31Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M50.68,25.87h0l-.14-.06V26l.16,0s.1,0,.16,0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M50.84,25.93l-.15.05v-.1Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32,28H18.21a2,2,0,0,1,0-4H32a2,2,0,0,1,0,4Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M36.13,37.92H18.21a2,2,0,0,1,0-4H36.13a2,2,0,1,1,0,4Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M36.31,48H18.4a2,2,0,0,1,0-4H36.31a2,2,0,0,1,0,4Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M52,19.94a2,2,0,0,0,2-2V8.08a4,4,0,0,0-4-4H22.94a2.83,2.83,0,0,0-2,.86L10.84,15a1.17,1.17,0,0,0-.28.36A2.7,2.7,0,0,0,10,17a.78.78,0,0,0,0,.3.88.88,0,0,0,0,.32V55.92a4,4,0,0,0,4,4H50a4,4,0,0,0,3.2-1.62c.12-.16.22-.3.32-.46A4.08,4.08,0,0,0,54,55.92V54.14a2,2,0,0,0-4,0v1.78H14v-36h9.54a2.77,2.77,0,0,0,2.16-1,4.39,4.39,0,0,0,.28-.36A2.82,2.82,0,0,0,26.42,17v-9H50v9.86A2,2,0,0,0,52,19.94Zm-29.58-4H15.56l.18-.18,6.68-6.7Z"
});

var SvgFoodRecord = function SvgFoodRecord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoodRecord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FoodRecord.30e2c93b.svg";
export { ForwardRef as ReactComponent };